import React from 'react';
import ReactDOM from 'react-dom';
import Configurator from './configurator.jsx';
import Bookkeeper from './bookkeeper.jsx';
import PhotoswipeGallery from './photoswipe-gallery.jsx';
import DetailTabs from './detail-tabs.jsx';
import MicroEvent from 'microevent';


// App exists instead of implementing full Flux application which is probably overkill here

window.polygon = window.polygon || {};
window.polygon.product = (function($) {

  var defaults = {
    optionSource: null,
    dataSource: null,
    initialVariants: [],    // coalesce initial variant
    configuratorTarget: 'configurator-react',
    bookkeeperTarget: 'bookkeeper',
    galleryTarget: 'gallery',
    detailTarget: 'details',
    purchaseWording: null,  // "Apply to purchase pricing"
    freightWording: null,   // "Please note an additional ${x} will be added..."
    buyAtWording: null,     // "After {x} months pay no more than ${y}"
    cartUrl: null,          // "/add-to-cart/{x}/?rate={y}"
    detailContainerClass: 'container'
  };

  let App = function(settings) {
    let self = this;
    self.initialVariants = settings.initialVariants;
    self.options = null;
    self.data = null;

    // if you want a reference to the component, assign the render call to a variable
    // let configurator = ReactDOM.render( ... );
    let configuratorTarget = document.getElementById(settings.configuratorTarget);
    if (configuratorTarget) {
      ReactDOM.render(
        React.createElement(Configurator, {
          app: self,
          onVariantChanged: onVariantChanged.bind(this),
          onUpdated: onConfiguratorUpdated.bind(this)
        }, null),
        configuratorTarget
      );
    }

    let bookkeeperTarget = document.getElementById(settings.bookkeeperTarget);
    if (bookkeeperTarget) {
      ReactDOM.render(
        React.createElement(Bookkeeper, {
          app: self,
          onUpdated: onBookkeeperUpdated.bind(this),
          buyAtWording: settings.buyAtWording,
          purchaseWording: settings.purchaseWording,
          freightWording: settings.freightWording,
          cartUrl: settings.cartUrl
        }, null),
        bookkeeperTarget
      );
    }

    let galleryTarget = document.getElementById(settings.galleryTarget);
    if (galleryTarget) {
      self.gallery = ReactDOM.render(
        React.createElement(PhotoswipeGallery, {
          app: self,
          onUpdated: onGalleryUpdated.bind(this),
          onReady: onGalleryReady.bind(this)
        }, null),
        galleryTarget
      );
    }

    let detailTarget = document.getElementById(settings.detailTarget);
    if (detailTarget) {
      ReactDOM.render(
        React.createElement(DetailTabs, {
          app: self,
          containerClass: settings.detailContainerClass,
          onUpdated: onDetailsUpdated.bind(this)
        }, null),
        detailTarget
      );
    }

    if (settings.optionSource) {
      $.get(settings.optionSource)
        .done(function (result) {
          self.options = result;
          self.trigger('OPTIONS_LOADED', result);
          fireInitialVariantEvent();
        })
        .fail(function () {
          self.trigger('OPTIONS_FAILED');
        });
    } else {
      self.trigger('OPTIONS_FAILED');
    }

    if (settings.dataSource) {
      $.get(settings.dataSource)
        .done(function (result) {
          self.data = result;
          self.trigger('DATA_LOADED', result);
          fireInitialVariantEvent();
        })
        .fail(function () {
          self.trigger('DATA_FAILED');
        });
    } else {
      self.trigger('DATA_FAILED');
    }

    function onVariantChanged(identity) {
      self.trigger('VARIANT_CHANGED', identity);
    }

    function onConfiguratorUpdated() {
      self.trigger('CONFIGURATOR_UPDATED');
      onComponentUpdated('configurator');
    }

    function onBookkeeperUpdated() {
      self.trigger('BOOKKEEPER_UPDATED');
      onComponentUpdated('bookkeeper');
    }

    function onGalleryUpdated() {
      self.trigger('GALLERY_UPDATED');
      onComponentUpdated('gallery');
    }

    function onGalleryReady() {
      self.trigger('GALLERY_READY');
    }

    function onDetailsUpdated() {
      self.trigger('DETAILS_UPDATED');
      onComponentUpdated('details');
    }

    function onComponentUpdated(name) {
      self.trigger('COMPONENT_UPDATED', name);
    }

    let firedInitialVariantEvent = false;
    function fireInitialVariantEvent() {
      if (!firedInitialVariantEvent && !configuratorTarget) {
        // fire the variant changed event on load if the configurator isn't present
        for (let i = 0; i < settings.initialVariants.length; i++) {
          if (settings.initialVariants[i] in self.data.variants) {
            self.trigger('VARIANT_CHANGED', settings.initialVariants[i]);
            break;
          }
        }
        firedInitialVariantEvent = true;
      }
    }
  };
  MicroEvent.mixin(App);

  return {
    Create(options) {
      let settings = $.extend({}, defaults);
      if (options) {
        $.extend(settings, options);
      }
      return new App(settings);
    }
  }
})(jQuery);




// WEBPACK FOOTER //
// ./js/products/app.es6